import { produce } from 'immer';
import type { AppFlowMetadata } from '@src/hooks/flow/useFlowConfigs';

type FilterRules = Array<
  Array<{
    field: string;
    op: string;
    value: string | number;
  }>
>;

export function appendFlowIdentifier(filterRules: FilterRules, flowIdentifier: string) {
  return produce(filterRules, (draft) => {
    draft.push([
      {
        field: 'flow_identifier',
        op: 'eq',
        value: flowIdentifier,
      },
    ]);
  });
}

// Append flow identifier to the filter
export function getFlowFilter(
  currentFilter: {
    rule?: FilterRules;
  },
  flowConfig?: AppFlowMetadata,
) {
  if (flowConfig?.identifier) {
    const nextRules = appendFlowIdentifier(currentFilter.rule ?? [], flowConfig.identifier);

    return produce(currentFilter, (draft) => {
      draft.rule = nextRules;
    });
  }

  return currentFilter;
}

export function getAllFlowInstancesFilter(filter: FilterRules) {
  return produce(filter, (draft) => {
    draft.push([
      {
        field: 'flow_identifier',
        op: 'starts_with',
        value: 'f_',
      },
    ]);
  });
}
